import { brandedUuid } from '../FlavorSchema.js';
export const ClientAccountIdSchema = brandedUuid('Invalid client account ID format');
//# sourceMappingURL=ClientAccountSchemas.js.map